import { combineReducers } from 'redux';
import identityReducer from './reducers/identity.reducer';
import {
  ACL_GROUP_LIST,
  ACL_PERMISSION_LIST,
  ACL_USER_LIST,
  AUTOVIEW_LIST,
  BADGE_LIST,
  BANNER_LIST,
  BANNER_SLIDER_LIST,
  CATEGORY_LIST,
  COLLECTION_LIST,
  COLLECTION_PHOTO_LIST,
  COLLECTION_TYPE_LIST,
  COMMENT_MEDIA,
  COMMENT_USER,
  CONTEST_LIST,
  CONTEST_TYPE_LIST,
  CONFIRMATION,
  EDITORIAL_AUTHOR_LIST,
  FEATURE_BOX_LIST,
  FEATURE_LOCATION_LIST,
  MEDIA_MENTION,
  MESSAGE_NOTIFICATION,
  MRSS_CATEGORY_LIST,
  MRSS_LIST,
  MRSS_MEDIA_LIST,
  MRSS_EIPSODES_LIST,
  PARTNER_LIST,
  PARTNER_EXCLUSIVE_LIST,
  PHOTO_LIST,
  REPORT_AIRVUZ_MRSS,
  REPORT_CONTRIBUTOR,
  REPORT_JUDGE,
  REPORT_JUDGE_COLLECTION,
  REPORT_JUDGE_ONE,
  REPORT_HEAVILY_COMMENT_MEDIA,
  REPORT_MISSING_CONTRIBUTOR,
  REPORT_NEW_CONTRIBUTOR,
  REPORT_NEW_USER,
  REPORT_SOCIAL_MEDIA_SHARE,
  REPORT_UPLOADS,
  REPORT_VIDEO_FEATURE_LIST,
  SITE_INFO,
  SNACKBAR,
  TOP_CONTRIBUTOR,
  TV_LIST,
  VIDEO_LIST,
  TV_FEATURE,
  UPLOAD_LIST,
  MRSS_SERIES_LIST,
  MESSAGE_NOTIFICATION_LIST,
} from './action/type.action';

import CreateReducer, { CreateBooleanReducer } from './reducers/reducer';

const videoFeatureState = {
  data: undefined,
  filterData: undefined,
  selectedData: [],
  check: undefined,
  param: {
    filter: 'all',
    param1: 'date',
    param1Value: '',
    camNFpvComponent: false,
    note: true,
    dvowNominee: false,
    dvowWinner: false,
    dvomNominee: false,
    dvomWinner: false,
    dvaNominee: false,
    dvaWinner: false,
    videoCollection: true,
    haveEditorial: false,
    promotionEmail: false,
    promotionSocial: false,
    userEmail: true,
  },
  getData: undefined,
  setControl: undefined,
};

const snackBarState = {
  open: false,
  duration: null,
  handleClose: null,
  variant: null,
  className: null,
  message: null,
  action: null,
};

const confirmationState = {
  open: false,
  title: '',
  handleClose: null,
  message: null,
  actions: null,
};

const droneTVState = {
  data: undefined,
  filterData: undefined,
  selectedData: undefined,
  check: undefined,
  param: undefined,
  getData: undefined,
  setControl: undefined,
  dataSource: {},
};

export default combineReducers({
  identity: identityReducer,
  backdrop: CreateBooleanReducer('LOADING_TRUE', 'LOADING_FALSE'),
  [SNACKBAR.name]: CreateReducer(SNACKBAR, snackBarState),
  [CONFIRMATION.name]: CreateReducer(CONFIRMATION, confirmationState),

  [ACL_GROUP_LIST.name]: CreateReducer(ACL_GROUP_LIST),
  [ACL_PERMISSION_LIST.name]: CreateReducer(ACL_PERMISSION_LIST),
  [ACL_USER_LIST.name]: CreateReducer(ACL_USER_LIST),
  [AUTOVIEW_LIST.name]: CreateReducer(AUTOVIEW_LIST),

  [BADGE_LIST.name]: CreateReducer(BADGE_LIST),
  [BANNER_LIST.name]: CreateReducer(BANNER_LIST),
  [BANNER_SLIDER_LIST.name]: CreateReducer(BANNER_SLIDER_LIST),

  [CATEGORY_LIST.name]: CreateReducer(CATEGORY_LIST),
  [COLLECTION_LIST.name]: CreateReducer(COLLECTION_LIST),
  [COLLECTION_PHOTO_LIST.name]: CreateReducer(COLLECTION_PHOTO_LIST),
  [COLLECTION_TYPE_LIST.name]: CreateReducer(COLLECTION_TYPE_LIST),
  [COMMENT_MEDIA.name]: CreateReducer(COMMENT_MEDIA),
  [COMMENT_USER.name]: CreateReducer(COMMENT_USER),
  [CONTEST_LIST.name]: CreateReducer(CONTEST_LIST),
  [CONTEST_TYPE_LIST.name]: CreateReducer(CONTEST_TYPE_LIST),

  [EDITORIAL_AUTHOR_LIST.name]: CreateReducer(EDITORIAL_AUTHOR_LIST),

  [FEATURE_BOX_LIST.name]: CreateReducer(FEATURE_BOX_LIST),
  [FEATURE_LOCATION_LIST.name]: CreateReducer(FEATURE_LOCATION_LIST),

  [MEDIA_MENTION.name]: CreateReducer(MEDIA_MENTION),
  [MESSAGE_NOTIFICATION.name]: CreateReducer(MESSAGE_NOTIFICATION),
  [MESSAGE_NOTIFICATION_LIST.name]: CreateReducer(MESSAGE_NOTIFICATION_LIST),
  [MRSS_CATEGORY_LIST.name]: CreateReducer(MRSS_CATEGORY_LIST),
  [MRSS_LIST.name]: CreateReducer(MRSS_LIST),
  [MRSS_MEDIA_LIST.name]: CreateReducer(MRSS_MEDIA_LIST),
  [MRSS_EIPSODES_LIST.name]: CreateReducer(MRSS_EIPSODES_LIST),
  [MRSS_SERIES_LIST.name]: CreateReducer(MRSS_SERIES_LIST),

  [PARTNER_LIST.name]: CreateReducer(PARTNER_LIST),
  [PARTNER_EXCLUSIVE_LIST.name]: CreateReducer(PARTNER_EXCLUSIVE_LIST),
  [PHOTO_LIST.name]: CreateReducer(PHOTO_LIST),

  [REPORT_AIRVUZ_MRSS.name]: CreateReducer(REPORT_AIRVUZ_MRSS),
  [REPORT_CONTRIBUTOR.name]: CreateReducer(REPORT_CONTRIBUTOR), //param
  [REPORT_JUDGE.name]: CreateReducer(REPORT_JUDGE),
  [REPORT_JUDGE_COLLECTION.name]: CreateReducer(REPORT_JUDGE_COLLECTION),
  [REPORT_JUDGE_ONE.name]: CreateReducer(REPORT_JUDGE_ONE),
  [REPORT_HEAVILY_COMMENT_MEDIA.name]: CreateReducer(REPORT_HEAVILY_COMMENT_MEDIA), //param
  [REPORT_MISSING_CONTRIBUTOR.name]: CreateReducer(REPORT_MISSING_CONTRIBUTOR), //param
  [REPORT_NEW_CONTRIBUTOR.name]: CreateReducer(REPORT_NEW_CONTRIBUTOR), //param
  [REPORT_NEW_USER.name]: CreateReducer(REPORT_NEW_USER), //param
  [REPORT_SOCIAL_MEDIA_SHARE.name]: CreateReducer(REPORT_SOCIAL_MEDIA_SHARE), //param
  [REPORT_UPLOADS.name]: CreateReducer(REPORT_UPLOADS),
  [REPORT_VIDEO_FEATURE_LIST.name]: CreateReducer(REPORT_VIDEO_FEATURE_LIST, videoFeatureState),

  [SITE_INFO.name]: CreateReducer(SITE_INFO),

  [TOP_CONTRIBUTOR.name]: CreateReducer(TOP_CONTRIBUTOR),
  [TV_LIST.name]: CreateReducer(TV_LIST, droneTVState),
  [TV_FEATURE.name]: CreateReducer(TV_FEATURE),

  [VIDEO_LIST.name]: CreateReducer(VIDEO_LIST), //time
  [UPLOAD_LIST.name]: CreateReducer(UPLOAD_LIST), //time
});
